import { create } from "zustand";
import { persist } from "zustand/middleware";

type Theme = 'light' | 'dark';

interface ClinicSettings {
  clinicName: string;
  address: string;
  country: string;
  phone: string;
  email: string;
  logo?: string;
  theme: Theme;
  setClinicName: (name: string) => void;
  setAddress: (address: string) => void;
  setCountry: (country: string) => void;
  setPhone: (phone: string) => void;
  setEmail: (email: string) => void;
  setLogo: (logo: string) => void;
  setTheme: (theme: Theme) => void;
}

export const useClinicSettings = create<ClinicSettings>()(
  persist(
    (set) => ({
      clinicName: "Saving Grace Clinic",
      address: "",
      country: "NG", // Default to Nigeria
      phone: "",
      email: "",
      logo: undefined,
      theme: 'dark',
      setClinicName: (name) => set({ clinicName: name }),
      setAddress: (address) => set({ address }),
      setPhone: (phone) => set({ phone }),
      setEmail: (email) => set({ email }),
      setLogo: (logo) => set({ logo }),
      setTheme: (theme) => set({ theme }),
      setCountry: (country) => set({ country }),
    }),
    {
      name: "clinic-settings",
    }
  )
);
